module.exports = __webpack_public_path__ + "img/preview-prize.670fa692.png";